export default __webpack_public_path__ + "static/media/avo_tuna_sndwch.d6a0fbb5.jpg";